/**
 * @desc create
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.OutPlanCreateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/outPlan/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
